module.exports = __webpack_public_path__ + "static/media/kit_LEDMiniBox_bg.334f97df.png";